<div id="{{ componentId }}" [ngSwitch]="testResultResponse">

	<!--Aria-hidden defined as true to ignore faicon selection-->
	<div class="test-status-icon success" *ngSwitchCase="testResultEnum.Pass">
		<fa-icon id="{{ componentId }}-pass" [attr.aria-label]="'Pass-icon'" role="img" class="success" [icon]="['fas', 'check']"></fa-icon>
	</div>
	<div class="test-status-icon failure" *ngSwitchCase="testResultEnum.Fail">
		<fa-icon id="{{ componentId }}-fail" [attr.aria-label]="'Fail-icon'" role="img" class="warning" [icon]="['fas', 'times']"></fa-icon>
	</div>
	<div class="test-status-icon warning" *ngSwitchCase="testResultEnum.Attention">
		<fa-icon id="{{ componentId }}-warning" [attr.aria-label]="'Warning-icon'" role="img" class="warning" [icon]="['fas', 'exclamation']"></fa-icon>
	</div>
	<div class="test-status-icon cancelled" *ngSwitchCase="testResultEnum.Cancelled">
		<fa-icon id="{{ componentId }}-cancelled" [attr.aria-label]="'Cancelled-icon'" role="img" class="cancelled" [icon]="['fas', 'minus']"></fa-icon>
	</div>
	<div class="test-status-icon not-applicable" *ngSwitchDefault>
		<fa-icon id="{{ componentId }}-not-applicable" [attr.aria-label]="'Not-Applicable-icon'" role="img" class="not-applicable" [icon]="['fas', 'minus']"></fa-icon>
	</div>
</div>
